export default "__VITE_ASSET__ISdZ4EfF__"